import React from "react";

export interface TabKeyValue {
  key: string;
  displayValue: string;
}

export interface TabProps<T> {
  tabs: TabKeyValue[];
  currentActiveTab: string;
  setCurrentActiveTab: (tab: T) => void;
  className?: string;
  hashNavigation?: boolean;
}

const TabsSelector = <T,>({
  tabs,
  currentActiveTab,
  setCurrentActiveTab,
  className,
  hashNavigation = true
}: TabProps<T>) => {
  React.useEffect(() => {
    if (!hashNavigation) return;
    const hash = window.location.hash.replace("#", "");
    if (hash && tabs.some(t => t.key === hash) && currentActiveTab !== hash) {
      setCurrentActiveTab(hash as unknown as T);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hashNavigation]);

  React.useEffect(() => {
    if (!hashNavigation) return;
    window.history.replaceState(null, "", `#${currentActiveTab}`);
  }, [hashNavigation, currentActiveTab]);
  return (
    <div
      className={`font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 ${className}`}
    >
      <ul className="flex flex-wrap -mb-px">
        {tabs.map(tab => (
          <li className="me-2" key={tab.key}>
            <div
              onClick={() => setCurrentActiveTab(tab.key as unknown as T)}
              className={`inline-block px-4 py-2 border-b-2 rounded-t-lg transition-all ${
                currentActiveTab === tab.key
                  ? "text-blue-600 border-blue-600 active dark:text-blue-500 dark:border-blue-500"
                  : "border-transparent hover:text-gray-600 hover:animate-pulse hover:border-gray-300 cursor-pointer"
              }`}
            >
              {tab.displayValue}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TabsSelector;
